import { customStyle, styleEnd } from "../../algorithms/styleDirection";
import { HubConnectionBuilder } from "@microsoft/signalr";
import * as signalR from "@microsoft/signalr";
import Icon from "../sharedComponents/icons/fontawsomeIcons";
import "./tasksStyle.css";
import TextArea from "../sharedComponents/textarea/textArea";
import Lang from "../../userPreferences/staticWords";
import { useEffect, useRef, useState } from "react";
import { paths } from "../../paths/paths";
import moment from "moment";
import "moment/locale/ar";
import Button from "../sharedComponents/buttons/button";
import {
  addComment,
  getComments,
} from "./../../API/store/actions/comments/comments";
import { useSelector } from "react-redux";
import { resolver } from "../../API/middlewares/resolveRequests";
import * as Constant from "../../constant.module.json";

const SubTaskComments = ({ displayComments, setDisplayComments }) => {
  const userLogged = useSelector((state) => state.login.userData);
  const userToken = useSelector((state) => state.login.userToken);
  const [comments, setComments] = useState([]);

  const [connection, setConnection] = useState(null);
  const [connectionId, setConnectionId] = useState(null);

  const [inputText, setInputText] = useState("");

  useEffect(() => {
    const connect = new HubConnectionBuilder()
      .withUrl(`${Constant.hubURLProjects}/commentHub`, {
        skipNegotiation: true,
        transport: signalR.HttpTransportType.WebSockets,
      })
      .withAutomaticReconnect()
      .build();
    setConnection(connect);
    return () => {
      connect.stop();
    };
  }, []);

  useEffect(() => {
    if (connection) {
      if (connection.state === "Disconnected") connection.start();
      connection.on("connected", (id) => {
        connection.invoke("JoinGroup", "subTaskComment" + displayComments.id);
        setConnectionId(id);
      });
      connection.on("ReceiveComment", (message) => {
        setDisplayComments({
          ...displayComments,
          content: [...displayComments.content, message],
        });
      });
    }
  }, [connection, displayComments.content]);
  useEffect(() => {
    if (displayComments.id) {
      setDisplayComments({ ...displayComments, content: [] });
      resolver(getComments, setComments, displayComments.id, userToken);
    }
  }, [displayComments.id]);

  useEffect(() => {
    if (comments?.data?.length)
      setDisplayComments({ ...displayComments, content: [...comments?.data] });
  }, [comments]);

  const sendMessage = async () => {
    const formData = new FormData();
    formData.append("Description", inputText);
    formData.append("UserId", userLogged.id);
    setInputText("");
    let res = await addComment(displayComments.id, formData, userToken);
    if (connection)
      await connection.invoke(
        "SendMessage",
        { ...res?.data },
        "subTaskComment" + displayComments.id,
      );
  };

  if (Lang.getLanguage() === "ar") moment.locale("ar");
  else moment.locale("en");

  // const messagesEndRef = useRef(null);

  // const scrollToBottom = () => {
  //   messagesEndRef.current?.scrollIntoView();
  // };
  // // { behavior: "smooth" }

  // useEffect(() => {
  //   scrollToBottom();
  // }, [comments, displayComments]);
  // useEffect(() => {
  // }, []);
  let userPhoto;
  let newCreateDate = String(displayComments?.owner?.createDate).split(".")[0];
  if (displayComments?.owner?.memberPhoto)
    userPhoto = `url("${paths.ApplicantPhoto}${displayComments.owner.memberId}/${displayComments.owner.memberPhoto}")`;
  else userPhoto = `url("/assets/images/userPlaceholder.png")`;
  if (comments)
    return (
      <>
        {displayComments.display ? (
          <div
            id="scroll"
            className={`scroll d-xl-flex d-none flex-lg-column col-3  ${customStyle(
              "fixedClass",
            )} overflow-auto px-2 mt-3`}
            style={{
              height: "85%",
            }}
          >
            <div className="d-flex justify-content-end mt-2">
              <Icon
                name="times"
                size={22}
                color={"#1A73E8"}
                onclick={() => {
                  setDisplayComments({
                    content: [],
                    id: null,
                    display: false,
                  });
                }}
              />
            </div>

            <div
              className={`my-2 p-2 ${customStyle("boxShadow")}`}
              style={{
                backgroundColor: "rgba(242, 242, 242, 1)",
                borderRadius: 8,
              }}
            >
              <div className="d-flex flex-xl-row flex-column align-items-center">
                <div className="d-flex mb-2 col-xl-7 col-12">
                  <div
                    style={{
                      backgroundImage: userPhoto,
                      width: 40,
                      height: 40,
                      borderRadius: "50%",
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "cover",
                      border: "1px solid white",
                    }}
                  ></div>
                  <p className="my-0 mx-1" style={{ fontWeight: "bold" }}>
                    {displayComments.owner.memberName}
                    <br />
                    <span className="text-muted" style={{ fontSize: 11 }}>
                      {`${moment(new Date(newCreateDate)).format("lll")}`}
                    </span>
                  </p>
                </div>
              </div>

              <div
                className="d-flex px-xl-2 px-4 align-items-center"
                style={{
                  textAlign: "justify",
                  fontSize: 16,
                  color: "#444444",
                }}
              >
                <p>{displayComments.owner.description}</p>
              </div>

              <hr className="m-0 mt-2" />

              <div className="d-flex align-items-center pt-2 mx-3 position-relative">
                <p className="m-0 px-2">{displayComments?.content?.length}</p>

                <svg
                  id="fi-br-comment-alt"
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 16 15.851"
                >
                  <path
                    id="Path_74"
                    data-name="Path 74"
                    d="M12.333,0H3.667A3.671,3.671,0,0,0,0,3.667v6a3.671,3.671,0,0,0,3.667,3.667h.959l2.733,2.285a1,1,0,0,0,1.283,0l2.733-2.285h.959A3.671,3.671,0,0,0,16,9.667v-6A3.671,3.671,0,0,0,12.333,0ZM14,9.667a1.667,1.667,0,0,1-1.667,1.667H11.011a1,1,0,0,0-.641.233L8,13.548,5.63,11.567a1,1,0,0,0-.641-.233H3.667A1.667,1.667,0,0,1,2,9.667v-6A1.667,1.667,0,0,1,3.667,2h8.667A1.667,1.667,0,0,1,14,3.667Z"
                    fill="rgb(26, 115, 232)"
                  />
                  <path
                    id="Path_75"
                    data-name="Path 75"
                    d="M7.167,8.333H9.5A1.167,1.167,0,0,0,9.5,6H7.167a1.167,1.167,0,0,0,0,2.333Z"
                    transform="translate(-2.667 -2.289)"
                    fill="rgb(26, 115, 232)"
                  />
                  <path
                    id="Path_76"
                    data-name="Path 76"
                    d="M14.853,11H7.265a1.265,1.265,0,0,0,0,2.529h7.588a1.265,1.265,0,0,0,0-2.529Z"
                    transform="translate(-3 -3.196)"
                    fill="rgb(26, 115, 232)"
                  />
                </svg>
              </div>
            </div>

            {/* <div className="d-flex col-12 my-2 px-0 justify-content-around">
              <div className="col-5 d-flex ">
                <p className="my-0" style={{ fontSiz: 12 }}>
                  {displayComments.content.length > 0
                    ? displayComments.content.length
                    : null}{" "}
                  {displayComments.content.length > 0
                    ? Lang.comments
                    : Lang.noComments}
                </p>
              </div>
              <hr className="col " style={{ height: 2, color: "#656565" }} />
            </div> */}

            <div
              style={{
                height: "55%",
                overflow: "auto",
              }}
            >
              {displayComments.content.map((comment, index) => {
                let userPhoto; //let newCreateDate,
                let newCreateDate = comment.createDate;
                if (comment.userPhoto != null)
                  userPhoto = `url("${paths.ApplicantPhoto}${comment.memberId}/${comment.memberPhoto}")`;
                else userPhoto = `url("/assets/images/userPlaceholder.png")`;
                return (
                  <div
                    className="p-2"
                    key={index + parseInt(comment.id) + comment.description}
                    style={{ wordBreak: "break-word" }}
                  >
                    <div className="d-flex flex-xl-row flex-column align-items-center">
                      <div className="d-flex align-items-center justify-content-xl-start justify-content-center mb-2 col-xl-7 col-12">
                        <div
                          style={{
                            backgroundImage: userPhoto,
                            width: 40,
                            height: 40,
                            borderRadius: "50%",
                            backgroundPosition: "center",
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "cover",
                            border: "1px solid white",
                          }}
                        ></div>
                        <p className="mx-1 my-0" style={{ fontWeight: "bold" }}>
                          {comment.userName}
                        </p>
                      </div>
                      <div className="d-flex align-items-center col">
                        <div className="d-flex mb-2">
                          {/* bind when date back from api */}
                          <span className="text-muted" style={{ fontSize: 14 }}>
                            {`${moment(new Date(newCreateDate)).format("lll")}`}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div
                      className="d-flex px-xl-2 px-4 align-items-center"
                      style={{
                        textAlign: "justify",
                        fontSize: 16,
                        color: "#444444",
                      }}
                    >
                      <p>{comment.description}</p>
                    </div>

                    {displayComments.content.length - index - 1 > 0 ? (
                      <div
                        style={{
                          backgroundColor: "#F2F2F2",
                          borderTopRightRadius: 10,
                          borderTopLeftRadius: 10,
                          borderBottom: "2px solid rgba(53, 132, 234, 0.5)",
                        }}
                        className="d-flex flex-wrap justify-content-around"
                      >
                        {comment.attachment ? (
                          <div
                            className="d-flex justify-content-center align-items-center py-3"
                            style={{ cursor: "pointer" }}
                          >
                            <div className="mx-2">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 16.049 15.568"
                              >
                                <path
                                  id="ic_attachment_24px"
                                  d="M0,3.972A3.97,3.97,0,0,1,3.972,0h7.583a2.889,2.889,0,1,1,0,5.777H5.416a1.805,1.805,0,1,1,0-3.611h5.416V3.611H5.351c-.4,0-.4.722,0,.722h6.2a1.444,1.444,0,1,0,0-2.889H3.972a2.528,2.528,0,1,0,0,5.055h6.861V7.944H3.972A3.97,3.97,0,0,1,0,3.972Z"
                                  transform="translate(0 9.664) rotate(-42)"
                                />
                              </svg>
                            </div>

                            <div>
                              {/* filename here */}
                              <p className="m-0">{comment.attachment}</p>
                            </div>
                          </div>
                        ) : null}
                      </div>
                    ) : null}

                    {/* <div ref={messagesEndRef}></div> */}
                  </div>
                );
              })}
            </div>
            <div className="fixedCommentSection" style={{ width: "inherit" }}>
              <div className="my-2 col-12">
                <TextArea
                  placeholderAR="أكتب رسالة"
                  placeholderEN="Write a message"
                  rows="2"
                  className="scroll col-12"
                  onChange={(input) => {
                    setInputText(input.target.value);
                  }}
                  value={inputText}
                />
              </div>

              <div className="mb-5 d-flex flex-row-reverse">
                <div className="col">
                  <Button
                    buttonStyleType={"solid"}
                    onClick={sendMessage}
                    disable={!inputText}
                    content={Lang.send}
                  />
                </div>
              </div>
            </div>
          </div>
        ) : null}

        {/* small screens to xl */}
        {displayComments.display ? (
          <div
            className={`scroll d-xl-none d-flex flex-column col-12 overflow-auto px-xl-5 px-4 `}
          >
            {displayComments.content.map((comment, index) => {
              let userPhoto; //let newCreateDate,
              // newCreateDate = procedure.createDate.split(".")[0];
              if (comment.memberPhoto != null)
                userPhoto = `url("${paths.ApplicantPhoto}${comment.memberId}/${comment.memberPhoto}")`;
              else userPhoto = `url("/assets/images/userPlaceholder.png")`;
              return (
                <div
                  className="p-2"
                  key={index}
                  style={{ wordBreak: "break-word" }}
                >
                  <div className="d-flex flex-row align-items-center">
                    <div className="d-flex align-items-center justify-content-start mb-2 mx-3 col-6">
                      <div
                        style={{
                          backgroundImage: userPhoto,
                          width: 40,
                          height: 40,
                          borderRadius: "50%",
                          backgroundPosition: "center",
                          backgroundRepeat: "no-repeat",
                          backgroundSize: "cover",
                          border: "1px solid white",
                        }}
                      ></div>
                      <p className="my-0 mx-1" style={{ fontWeight: "bold" }}>
                        {comment.memberName}
                      </p>
                    </div>
                    <div className="d-flex align-items-center justify-content-end col-6 px-5">
                      <div className="d-flex mb-2">
                        <span className="text-muted" style={{ fontSize: 14 }}>
                          {`${moment(new Date(comment.createDate)).format(
                            "lll",
                          )}`}{" "}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div
                    className="d-flex px-xl-2 px-4 align-items-center"
                    style={{
                      textAlign: "justify",
                      fontSize: 16,
                      color: "#444444",
                    }}
                  >
                    <p>{comment.description}</p>
                  </div>
                </div>
              );
            })}
            <div className="mt-4 mb-2 col-12 px-4">
              <TextArea
                placeholderAR="أكتب رسالة"
                placeholderEN="Write a message"
                rows="2"
                className="scroll col-12"
                onChange={(input) => {
                  setInputText(input.target.value);
                }}
                value={inputText}
              />
            </div>

            <div className="mb-3 px-4 d-flex ">
              <div className="col">
                <Button
                  onClick={sendMessage}
                  disable={!inputText}
                  content={Lang.send}
                />
              </div>
            </div>
          </div>
        ) : null}
      </>
    );
  return <>Loading</>;
};

export default SubTaskComments;
